const state = {
  services: [],
  services_selected: [],
}

export const customQcRequiredFields = [
  { key: 'qc.services' },
]

export default state
